import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Filter, { FilterModal, FilterSection } from './Filter';
import UtrFilterComponent from './FilterComponents/UtrFilterComponent';
import CheckboxFilterByType from './FilterComponents/CheckboxFilterByType';
import styles from '../search.scss';
import { filterTypes } from '../../../utils/constants';

const EventsMoreDesktopFilter = (props) => {
    const { filterInputs, filters, handleFilterClick, filterModal, closeModals, handleFilterSubmit, clearFilters, eventsMoreDesktopFiltersAreActive, searchTypes, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;
    const sportTypes = filterInputs?.sportTypes;
    const showTennisContent = sportTypes?.tennis;
    // Skip the eventTeamTypes/genders reset on the first effect run so that
    // URL-hydrated filters (NL search, bookmarked links) survive mount.
    const isInitialMount = useRef(true);
    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }
        handleFilterUpdate({
            eventTeamTypes: {
                singles: false,
                doubles: false,
            },
            genders: {
                f: false,
                m: false,
            },
        });
    }, [filterInputs?.sportTypes?.tennis, filterInputs?.sportTypes?.pickleball]);

    const getTennisMoreDesktopFilter = () => {
        return showTennisContent ? filterTypes.TENNIS_FILTER : filterTypes.PICKLEBALL_FILTER;
    };

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'eventsMoreDesktop'}
                handleFilterClick={handleFilterClick}
                isActive={eventsMoreDesktopFiltersAreActive || filterModal === 'eventsMoreDesktop'}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                More...
            </Filter>
            {filterModal === 'eventsMoreDesktop' && (
                <FilterModal
                    title={'More...'}
                    onCloseClick={closeModals}
                    clearFilters={() => clearFilters('eventsMoreDesktop', true)}
                    scrollable={true}
                    handleFilterSubmit={handleFilterSubmit}
                    pickleballDeskTopMore={!showTennisContent ? filterTypes.PICKLEBALL_FILTER : ''}
                    data-testid={dataTestId}
                >
                    <FilterSection data-testid={dataTestId && `${dataTestId}.body`}>

                        <UtrFilterComponent
                            filterInputs={props.filterInputs}
                            filters={filters}
                            showExpandedUtrFilter={false}
                            handleUTRChange={(range) => {
                                handleFilterUpdate({
                                    utrMin: range[0],
                                    utrMax: range[1],
                                });
                            }}
                            handleUtrTypeClick={(utrType) => {
                                handleFilterUpdate({ utrType });
                            }}
                            handleUtrTeamTypeClick={(utrTeamType) => {
                                handleFilterUpdate({ utrTeamType });
                            }}
                            handleUtrReliabilityClick={(utrReliability) => {
                                handleFilterUpdate({ utrReliability });
                            }}
                            TennisMoreDesktopFilter={getTennisMoreDesktopFilter()}
                            data-testid={dataTestId && `${dataTestId}.utr-filter`}
                        />

                        {!!showTennisContent && <div className={styles.searchFilterModalDiv} />}
                        <div className={styles.searchFilterModalTitle} data-testid={dataTestId && `${dataTestId}.game-type-title`}>Game Type</div>
                        <CheckboxFilterByType
                            searchTypes={searchTypes}
                            searchTypesPropName={`eventTeamTypes`}
                            filterInputs={filterInputs}
                            filtersPropName={`eventTeamTypes`}
                            onChange={(value) => {
                                handleFilterUpdate({
                                    eventTeamTypes: {
                                        ...filterInputs.eventTeamTypes,
                                        [value]: !filterInputs.eventTeamTypes[value],
                                    },
                                });
                            }}
                            data-testid={dataTestId && `${dataTestId}.game-type-options`}
                        />
                        {!!showTennisContent && (
                            <>
                                <div className={styles.searchFilterModalDiv} />
                                <div className={styles.searchFilterModalTitle} data-testid={dataTestId && `${dataTestId}.gender-title`}>Gender</div>
                                <CheckboxFilterByType
                                    searchTypes={searchTypes}
                                    searchTypesPropName={`eventGenders`}
                                    filterInputs={filterInputs}
                                    filtersPropName={`genders`}
                                    onChange={(value) => {
                                        handleFilterUpdate({
                                            genders: {
                                                ...filterInputs.genders,
                                                [value]: !filterInputs.genders[value],
                                            },
                                        });
                                    }}
                                    data-testid={dataTestId && `${dataTestId}.gender-options`}
                                />
                            </>
                        )}
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

EventsMoreDesktopFilter.propTypes = {
    filterInputs: PropTypes.instanceOf(Object).isRequired,
    filters: PropTypes.instanceOf(Object).isRequired,
    handleFilterClick: PropTypes.func.isRequired,
    filterModal: PropTypes.string.isRequired,
    closeModals: PropTypes.func.isRequired,
    handleFilterSubmit: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
    eventsMoreDesktopFiltersAreActive: PropTypes.bool,
    handleFilterUpdate: PropTypes.func.isRequired,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    'data-testid': PropTypes.string,
};

EventsMoreDesktopFilter.defaultProps = {
    eventsMoreDesktopFiltersAreActive: false,
    mobileOnly: false,
    desktopOnly: false,
    'data-testid': null,
};

export default EventsMoreDesktopFilter;
